import React, { useState, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

import { materialPropertyService } from "/app/src/services";

import Search from "../search";

import { useTranslation } from "react-i18next";
import { MaterialProperty as MaterialPropertyType } from "/app/src/models";
import { createColumnHelper } from "@tanstack/react-table";
import Table from "/app/src/components/generic/tables/table";
import { useSortUpgrade } from "/app/src/hooks/useSortUpgrade";
import usePaginatedData from "/app/src/hooks/usePaginatedData";
export default function MaterialProperties() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [sort, setSort] = useSortUpgrade([]);
  const [searchString, setSearchString] = useState("");

  const columnHelper = createColumnHelper<MaterialPropertyType>();
  const columns = useMemo(
    () => [
      columnHelper.accessor("name", {
        id: "name",
        cell: (info) => info.getValue(),
        header: t("translation:name"),
      }),
      columnHelper.accessor("expiryDatePickType", {
        id: "expiryDatePickType",
        cell: (info) => info.getValue(),
        header: t("translation:expiry"),
      }),
    ],
    [columnHelper, t],
  );

  const goToMaterialProperty = useCallback(
    (materialPropertyId: number) => {
      navigate(`/explorer/material_properties/${materialPropertyId}`);
    },
    [navigate],
  );

  const {
    data: materialProperties,
    count: materialPropertiesCount,
    isFetching,
  } = usePaginatedData<MaterialPropertyType>({
    queryKey: ["material_properties"],
    page,
    pageSize,
    searchString,
    sort,
    service: materialPropertyService,
  });

  return (
    <div className="explorer">
      <Helmet>
        <title>{t("translation:material_properties")} - ItemPath</title>
      </Helmet>
      <div className="search box">
        <Search setSearchString={setSearchString} />
      </div>
      <Table
        loading={isFetching}
        rows={materialProperties}
        tableColumns={columns}
        length={materialPropertiesCount}
        sort={sort}
        setSort={setSort}
        paginationEnabled={{
          currentPage: page,
          pageSize,
          setPage,
          setPageSize,
        }}
        enableRowSelection
        rowClicked={goToMaterialProperty}
        emptyText={`${t("translation:no")} ${t(
          "translation:material_properties",
        )} ${t("translation:found")}`}
      />
    </div>
  );
}
